export const toggleModal = (label?: string) => {
  if (typeof window === 'undefined' || !label) return;

  const { body } = document;
  const modalElement = document.querySelector(
    `dialog#${label}`,
  ) as HTMLDialogElement | null;

  if (!modalElement) return;

  if (modalElement.open) {
    modalElement.close();
    body?.classList.remove('hideOverflow');
  } else {
    modalElement.showModal();
    body?.classList.add('hideOverflow');
  }
};

export const closeModal = (label?: string) => {
  const body = window.document.querySelectorAll('body')[0];
  const modalElement = window.document.querySelector(
    `dialog#${label}`,
  ) as HTMLDialogElement;

  if (body) body.classList.remove('hideOverflow');
  modalElement.close();
};
